/**
 * Dagitim kaymasi: sayfa eski derlemeden, paketler yeni derlemeden geldiginde
 * tarayici "ChunkLoadError" ya da "Failed to find Server Action" gorur. Bu
 * hatalar kodun degil anin hatasidir; sayfa bir kez yenilenince gecer.
 *
 * Yenileme oturum basina bir kez yapilir; hata gercekse donguye girilmez.
 */
const YENILEME_ANAHTARI = 'biyo:hata-yenileme';

export function dagitimKaymasiMi(error: unknown): boolean {
  const e = error as { name?: string; message?: string } | null;
  const metin = `${e?.name ?? ''} ${e?.message ?? ''}`;
  return /ChunkLoadError|Loading chunk|Loading CSS chunk|Failed to fetch dynamically imported module|Importing a module script failed|Failed to find Server Action/i.test(metin);
}

/** true donerse sayfa yenileniyor; cagiran hata ekranini cizmeyebilir. */
export function birKezYenile(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    if (sessionStorage.getItem(YENILEME_ANAHTARI) === '1') return false;
    sessionStorage.setItem(YENILEME_ANAHTARI, '1');
  } catch {
    // Depolama yoksa yenileme donguye girebilir; bu durumda hic yenilemiyoruz.
    return false;
  }
  window.location.reload();
  return true;
}

/** Hata ekrani gorunurken arama motoru bu hali dizine almasin. */
export function dizineAlmaIsaretiKoy(): () => void {
  if (typeof document === 'undefined') return () => {};
  const meta = document.createElement('meta');
  meta.name = 'robots';
  meta.content = 'noindex';
  meta.setAttribute('data-hata-ekrani', '1');
  document.head.appendChild(meta);
  return () => { meta.remove(); };
}
